export { Flatbed } from './Flatbed';
